import React from 'react';
import classnames from 'classnames';
import { compose } from 'redux';
import {
  withMobile, Text, Container, withStyles, withBreakpoint,
} from 'components/common';

const General = ({
  user: {
    first_name,
    last_name,
  },
  mobileContext: { isMobile },
}) => {
  return (
    <Container className={`px-6 ${isMobile ? "" : "border rounded shadow-md"}`} >
      <div className="flex flex-col md:flex-row justify-between">
        <div className="flex md:justify-between">
          <Text
            className={classnames("font-bold text-xl")}
          >
            {first_name || "unknown"} {last_name || "unknown"}
          </Text>
        </div>
      </div>
    </Container>
  );
};

export default compose(withStyles, withMobile, withBreakpoint)(General);
